<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        text
        icon
        v-on="on"
      >
        <v-icon>mdi-note-plus</v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Employee Incidents"
      text="Create Employee Incidents"
      class="mb-0"
    > 
      <form>
        <v-container v-if="dialog">
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="type"
                v-validate="'required'"
                :error-messages="errors.collect('incident_type_id')"
                :items="types"
                :loading="loading"
                data-vv-name="incident_type_id"
                data-vv-as="type"
                item-text="name"
                item-value="id"
                label="Type"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="subject"
                v-validate="'required|max:255'"
                :error-messages="errors.collect('subject')"
                data-vv-name="subject"        
                label="Subject"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="description"
                v-validate="'required|max:2000'"
                :rows="4"
                :error-messages="errors.collect('description')"
                data-vv-name="description"        
                label="Description"
              />
            </v-col>
            <v-col cols="12">
              <helper-file-input
                v-model="file" 
                :max-size-in-mb="2"
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"
                accept-type=".pdf"    
                extension="ext:pdf"      
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add file
                  </v-btn>
                  <span> 
                    {{ file ? '' : 'No file chosen (.pdf only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <span class="font-weight-bold">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    inject: ['$validator'],
    props: {
      employeeUid: {
        type: String, 
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        loading: false,
        dialog: false,
        subject: '',
        description: '',
        type: null,
        types: [],
        file: null,
      }
    },
    watch: {
      dialog (value) {
        if (value) {
          this.loadTypes()
        } else {
          this.$resetData()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.incidents().create(this.employeeUid, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('created')
                  this.$snack({ message: 'Incident created' })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      loadTypes () {
        this.loading = true

        this.$api.incidentTypes().list()
          .then(response => {
            this.types = response.data

            this.loading = false
          })
      },
      prepareFormData () {
        if (this.file) {
          this.file.formData.set('subject', this.subject)
          this.file.formData.set('description', this.description)
          this.file.formData.set('incident_type_id', this.type)

          return this.file.formData
        }

        let formData = new FormData()

        formData.append('subject', this.subject)
        formData.append('description', this.description)
        formData.append('incident_type_id', this.type)

        return formData
      },
    },
  }
</script>
